
import { dataStorageService } from '../../../shared/services/dataStorageService';

/**
 * DataLoaderService provides unified access to downloaded scenario private.
 */
export const dataLoaderService = {
    /**
     * Loads all available lessons from storage, grouped by file.
     * Returns an array of groups: [{ id, name, lessons: [] }]
     */
    async getAllGroups() {
        const manifest = await dataStorageService.getVersionInfo();
        if (!manifest || !manifest.files) return [];

        const groups = [];
        const fileEntries = Object.entries(manifest.files);
        
        // Optional: sort by order if present
        fileEntries.sort((a, b) => (a[1].order || 0) - (b[1].order || 0));

        for (const [fileKey, fileInfo] of fileEntries) {
            const data = await dataStorageService.getData(fileKey);
            if (data && Array.isArray(data)) {
                groups.push({
                    id: fileKey,
                    name: fileInfo.name || fileKey,
                    lessons: data
                });
            }
        }
        
        return groups;
    },

    /**
     * Legacy method for backward compatibility, returns flat list of first group's lessons
     */
    async getAllLessons() {
        const groups = await this.getAllGroups();
        return groups.length > 0 ? groups[0].lessons : [];
    },

    /**
     * Loads a specific lesson by ID.
     * Supports composite IDs: "fileKey-index" (e.g., "studyless_pre-0")
     * Also supports legacy simple index IDs (defaults to first file)
     */
    async getLessonById(id) {
        let fileKey = null;
        let index = null;

        if (typeof id === 'string' && id.includes('-')) {
            const parts = id.split('-');
            index = parseInt(parts.pop(), 10);
            fileKey = parts.join('-');
        } else {
            // Legacy support: numeric ID refers to the first file in manifest
            index = parseInt(id, 10);
            const manifest = await dataStorageService.getVersionInfo();
            if (manifest && manifest.files) {
                fileKey = Object.keys(manifest.files)[0];
            }
        }

        if (!fileKey || isNaN(index)) return null;

        const data = await dataStorageService.getData(fileKey);
        if (data && Array.isArray(data)) {
            return data[index] || null;
        }
        
        return null;
    }
};
